import styled from 'styled-components';
import { colors } from '../../../variables/colors.js';

var Footer = styled.div.withConfig({
  displayName: "footer__Footer",
  componentId: "sc-13fvdmj-0"
})(["background-color:", ";bottom:0;height:auto;padding:24px;position:absolute;width:100%;"], colors.lightGray);

export { Footer };
//# sourceMappingURL=footer.js.map
